import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
    transform(value: string, args: string, inEditMode: boolean): any {
        try {
            let containsHyperLinks = value.indexOf('<a href') > -1
            value = value.replace(/  /g, " &nbsp;").replace(/\n/g, "<br />");
            if (value.endsWith("<br />")) value += "&nbsp;";
            if (args != null && args.trim().length > 0) {
                let re = new RegExp(args.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
                if (!inEditMode) {
                    if (containsHyperLinks) {
                        let regExpLink = new RegExp('(?<!<[^>]*)' + args.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?<![^>]*<)', 'gi');
                        let indexes = [];
                        let ind = regExpLink.exec(value);                      
                        while (ind) {
                            indexes.push(ind)
                            ind = regExpLink.exec(value)
                        }
                        indexes = indexes.map(i => {
                            return i.index
                        });

                        value = value.replace(re, (word, i) => {
                            if (indexes.includes(i)) {
                                return '<mark class="highlight">' + word + '</mark>';
                            }
                            return word;
                        });
                    } else {
                        value = value.replace(re, (word) => {
                            return '<mark class="highlight">' + word + '</mark>';
                        });
                    }                    
                }
                return value + '<br />';
            }           
        } catch (e) { }
        return value;            
    }
}
